import React from 'react';
import { Form, Spin, Upload, Input, Tooltip, Icon, Select, Row, Col, Button } from 'antd';
import { getCategoriesV2List, uploadLogo, postTag } from '../../modules/Api';
import { END_POINT } from '../../constants/config';
import history from '../../modules/History';
import SitemapChangeFreqInput from '../../components/SitemapChangeFreqInput.js';
// import MDEditor from '@uiw/react-md-editor';
import Editor from 'for-editor'
const EditorToolbar = {
  h1: false, 
  h2: true, 
  h3: true, 
  h4: true, 
  h5: true, 
  img: false, 
  link: true, 
  code: false, 
  preview: true, 
  expand: true, 
  /* v0.0.9 */
  undo: true, 
  redo: true, 
  save: false, 
  /* v0.2.3 */
  subfield: true,
}

const FormItem = Form.Item;
const Option = Select.Option;

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class StoreForm extends React.Component {
    constructor() {
        super();
        this.state = {
            categories: [],
            tags: [],
            selectedTags: [],
            storeLogo: null,
            subcategories: [],
        }
    }

    componentDidMount() {
        const filter = {
            parent_id: 12,
        }

        const query = 'filter='+JSON.stringify(filter);
        getCategoriesV2List(query, res => {
            this.setState({categories: res.data})
        });
    }

    getSubcategories = (parent_id) => {
        const filter = {
            parent_id: parent_id,
        }

        const query = 'filter='+JSON.stringify(filter);
        getCategoriesV2List(query, res => {
            this.setState({subcategories: res.data})
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.initialData.logo && this.state.storeLogo === null) {
            this.setState({storeLogo: nextProps.initialData.logo});
        }
        if (this.state.selectedTags.length === 0 && nextProps.initialData.tag && nextProps.initialData.tag.length > 0) {
            this.setState({selectedTags: nextProps.initialData.tag});
        }
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            this.props.submit(Object.assign({}, fieldsValue, {logo: this.state.storeLogo, tag: this.state.selectedTags.map(t => t.key)}));
        })
    }

    fetchTag(keyword) {
        if(!(keyword === null || keyword === undefined || keyword === '')) {
            this.setState({tags: [{text: keyword, value: keyword}]});
        }
    }

    commitTags(items) {
        this.setState({tags: [], selectedTags: items});

        items.forEach(t => {
            postTag({title: t.label}, id => {
                this.setState({selectedTags: this.state.selectedTags.map(d => {
                    return d.label === t.label ? Object.assign({}, d, {key: id}) : d;
                })});
            });
        });
    }

    render() {
        const formItemLayout = {
            labelCol: {
            xs: { span: 24 },
            sm: { span: 24 },
            },
            wrapperCol: {
            xs: { span: 24 },
            sm: { span: 24 },
            },
        };
        const { getFieldDecorator, getFieldsError } = this.props.form;

        return (
            <div style={{direction: 'rtl'}}>
            <Form onSubmit={this.handleSubmit}>
                <Row>
                    <Col span={10} offset={1}>
                        <FormItem
                        {...formItemLayout}
                        label="دسته بندی"
                        colon={false}>
                            {getFieldDecorator('category_id', {
                                initialValue: this.props.initialData.category_id,
                                rules: [
                                { required: true, message: 'دسته بندی فروشگاه را انتخاب نمایید!' },
                                ],
                            })(
                                <Select
                                onSelect={(value, option) => this.getSubcategories(value)}
                                placeholder="انتخاب دسته بندی" style={{width: '200px'}}>
                                    {this.state.categories.map(s => <Option value={s.id.toString()} key={`ss__${s.id}`}>{s.name}</Option>)}
                                </Select>
                            )}
                        </FormItem>

                        <FormItem
                        {...formItemLayout}
                        label="زیر دسته"
                        colon={false}>
                            {getFieldDecorator('subcategory_id', {
                                initialValue: this.props.initialData.subcategory_id,
                                rules: [
                                ],
                            })(
                                <Select
                                placeholder="انتخاب زیر دسته بندی" style={{width: '200px'}}>
                                    {this.state.subcategories.map(s => <Option value={s.id.toString()} key={`ss__${s.id}`}>{s.name}</Option>)}
                                </Select>
                            )}
                        </FormItem>

                        <FormItem
                        {...formItemLayout}
                        label="تگ ها"
                        colon={false}>
                            {getFieldDecorator('tag', {
                                initialValue: this.props.initialData.tag,
                                rules: [
                                ],
                            })(
                                <Select
                                    mode="multiple"
                                    labelInValue
                                    value={this.state.selectedTags}
                                    placeholder="انتخاب تگ"
                                    notFoundContent={this.state.loading ? <Spin size="small" /> : null}
                                    filterOption={false}
                                    onSearch={this.fetchTag.bind(this)}
                                    onChange={this.commitTags.bind(this)}
                                    style={{ width: '200px' }}>
                                    {this.state.tags.map(d => <Option key={d.value}>{d.text}</Option>)}
                                </Select>
                            )}
                        </FormItem>

                        <FormItem
                        {...formItemLayout}
                        label="لوگو فروشگاه"
                        extra="بهتر است فایل انتخابی مربعی و حداقل عرض ۳۰۰ پیکسل و فرمت jpg باشد."
                        colon={false}>
                        {getFieldDecorator('upload', {
                            valuePropName: 'fileList',
                            getValueFromEvent: this.normFile,
                        })(
                            <Upload
                            name="logo"
                            action=""
                            customRequest={() => {}}
                            onChange={f => {uploadLogo(f, (src) => {this.setState({storeLogo: src})})}}
                            listType="picture"
                            showUploadList={false}>
                            <Button>
                                <Icon type="upload" /> انتخاب فایل
                            </Button>
                            <br />
                            {this.state.storeLogo && <img src={`${this.state.storeLogo.includes('http') ? this.state.storeLogo : END_POINT + this.state.storeLogo}`} style={{width: '50px', height: '50px', margin: '10px'}} alt="لوگو فروشگاه"/>}
                            </Upload>
                        )}
                        </FormItem>
                        {SitemapChangeFreqInput(this.props.initialData.sitemap_change_freq, getFieldDecorator, formItemLayout)}

                        <FormItem
                            {...formItemLayout}
                            label="اولویت نقشه سایت"
                            colon={false}>
                            {getFieldDecorator('sitemap_priority', {
                                initialValue: this.props.initialData.sitemap_priority
                            })(
                                <Input />
                            )}
                        </FormItem>
                    </Col>

                    <Col span={11} offset={1}>
                    <FormItem
                        {...formItemLayout}
                        label="نام"
                        colon={false}>
                        {getFieldDecorator('name', {
                            initialValue: this.props.initialData.name,
                            rules: [{
                            required: true, message: 'نام فروشگاه را وارد نمایید',
                            }],
                        })(
                            <Input />
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="توضیحات(درباره فروشگاه)"
                        colon={false}>
                        {getFieldDecorator('description', {
                            initialValue: this.props.initialData.description,
                            rules: [{
                            required: true, message: 'توضیحات فروشگاه را وارد نمایید!',
                            }],
                        })(
                            <Editor placeholder="توضیحات(درباره فروشگاه)" toolbar={EditorToolbar}/>
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="نام نمایشی در آدرس فروشگاه (درون سایت)"
                        colon={false}>
                        {getFieldDecorator('slug', {
                            initialValue: this.props.initialData.slug,
                            rules: [{
                                required: true, message: 'پر کردن این فیلد ضروری است',
                            }],
                        })(
                            <Input />
                        )}
                        <Tooltip title="توجه داشته باشید ویرایش این فیلد در SEO تاثیر گذار است لذا در هنگام افزودن و ویرایش دقت لازم را داشته باشید .">
                            <span style={{color: 'green'}}> *نکته!</span>
                        </Tooltip>
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="وب سایت"
                        colon={false}>
                        {getFieldDecorator('website', {
                            initialValue: this.props.initialData.website,
                            rules: [],
                        })(
                            <Input />
                        )}
                    </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="توضیحات کوتاه (2 یا 3 خط)"
                            colon={false}>
                            {getFieldDecorator('short_description', {
                                initialValue: this.props.initialData.short_description,
                                rules: [
                                    {
                                        required: false
                                    }
                                ],
                            })(
                                <Input.TextArea />
                            )}
                        </FormItem>
                    <FormItem
                        {...formItemLayout}
                        label="عنوان متا"
                        colon={false}>
                        {getFieldDecorator('meta_title', {
                            initialValue: this.props.initialData.meta_title,
                            rules: [
                                {
                                    required: false
                                }
                            ],
                        })(
                            <Input />
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="توضیحات متا"
                        colon={false}>
                        {getFieldDecorator('meta_description', {
                            initialValue: this.props.initialData.meta_description,
                            rules: [
                                {
                                    required: false
                                }
                            ],
                        })(
                            <Input.TextArea />
                        )}
                    </FormItem>

                    {/* <FormItem
                        {...formItemLayout}
                        label="لینک راهنما"
                        colon={false}>
                        {getFieldDecorator('hint_link', {
                            initialValue: this.props.initialData.hint_link,
                            rules: [
                                {
                                    required: false
                                }
                            ],
                        })(
                            <Input />
                        )}
                    </FormItem> */}
                    </Col>


                </Row>
                <FormItem>
                    <div className="btn-container">
                        <Button
                            type="primary"
                            htmlType="submit"
                            disabled={hasErrors(getFieldsError()) || this.props.submitted}
                        >
{this.props.submitted ? 'منتظر بمانید' : ' ثبت'}
                        </Button>

                        {
                            this.props.initialData.id &&
                            <Button type="secondary" onClick={() => history.item.push(`/history/brand/${this.props.initialData.id}`)}>تاریخچه تغییرات</Button>
                        }
                    </div>
                </FormItem>
            </Form>
        </div>
        )
    }
}

StoreForm.defaultProps = {
    initialData: {}
}

export default Form.create()(StoreForm);


// WEBPACK FOOTER //
// ./src/containers/Stores/form.js